var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Play",
    d: "M16.658,32.848a14.367,14.367,0,0,0,5.79-1.181,15.378,15.378,0,0,0,8.029-8.029,14.431,14.431,0,0,0,1.173-5.8,14.367,14.367,0,0,0-1.181-5.79,15.463,15.463,0,0,0-3.25-4.794,15.089,15.089,0,0,0-4.786-3.242,14.53,14.53,0,0,0-5.79-1.166A14.475,14.475,0,0,0,10.86,4.013,15.335,15.335,0,0,0,2.824,12.05,14.448,14.448,0,0,0,1.65,17.84a14.35,14.35,0,0,0,1.181,5.8,15.45,15.45,0,0,0,8.029,8.029A14.35,14.35,0,0,0,16.658,32.848Zm0-2.748a12.018,12.018,0,0,1-4.771-.95,12.269,12.269,0,0,1-6.531-6.539A12.265,12.265,0,0,1,11.879,6.538,12.048,12.048,0,0,1,16.643,5.6a12.258,12.258,0,0,1,8.693,20.921,12.3,12.3,0,0,1-3.906,2.633A12.018,12.018,0,0,1,16.658,30.1ZM13.91,23.584l8.353-4.925a.914.914,0,0,0,0-1.59L13.91,12.127a1.087,1.087,0,0,0-.98-.085.723.723,0,0,0-.5.733V22.951a.74.74,0,0,0,.486.733A1.041,1.041,0,0,0,13.91,23.584Z",
    transform: "translate(-1.65 -2.848)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.58b7a5994c9db25b72c8be42fec1611c.svg";
export { ForwardRef as ReactComponent };